import { gql, useMutation } from '@apollo/client';
import { Button } from '@mui/joy';
import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { showMessage } from '../../store/snackbar-slice';

const writeBedSensorSettingsMutation = gql`
  mutation WriteBedSensorSettings($_id: ID!) {
    writeBedSensorSettings(_id: $_id)
  }
`;

interface Props {
  _id: string;
}

function SaveSettingsButton({ _id }: Props) {
  const [writeSettings] = useMutation(writeBedSensorSettingsMutation);
  const [saving, setSaving] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const onClick = useCallback(async () => {
    navigate(`/bed-sensors/view/${_id}/commands`);
    setSaving(true);
    try {
      await writeSettings({ variables: { _id } });
      dispatch(
        showMessage({
          _id: 'write-bed-sensor-settings',
          severity: 'success',
          message: 'Success',
        }),
      );
    } catch (err: any) {
      console.error(err);
      dispatch(
        showMessage({
          _id: 'write-bed-sensor-settings',
          severity: 'danger',
          message: 'There was an error saving settings.',
        }),
      );
    }
    setSaving(false);
  }, [writeSettings, dispatch, navigate, _id]);

  return (
    <Button loading={saving} onClick={onClick} variant="solid" size="sm">
      Save Settings to Sensor
    </Button>
  );
}

export default SaveSettingsButton;
